"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Media, Separator, SpaceBetween } from "@opensea/ui-kit";
import { useShallow } from "zustand/react/shallow";
import { ItemSelectionActionBar } from "@/components/items/ItemSelectionActionBar";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { useProfileTokensSelectionStore } from "../ProfileTokensSelectionProvider";
import { MobileProfileTokensActionBar } from "./MobileProfileTokensActionBar";
import { ProfileTokensSelectionClearAll } from "./ProfileTokensSelectionClearAll";
import { ProfileTokensSelectionPreview } from "./ProfileTokensSelectionPreview";
import { TokenHideButton } from "./TokenHideButton";
export function ProfileTokensActionBar(t0) {
  const $ = _c(18);
  const {
    onRefetch
  } = t0;
  const [selectedTokensMap] = useProfileTokensSelectionStore(useShallow(_temp));
  const hasSelectedTokens = selectedTokensMap.size > 0;
  const isOwnProfileAddress = useIsOwnProfileAddress();
  if (!isOwnProfileAddress) {
    return null;
  }
  if (!hasSelectedTokens) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProfileTokensSelectionPreview />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== hasSelectedTokens) {
    t2 = hasSelectedTokens ? <Separator className="mx-0 h-6 md:mx-3" orientation="vertical" /> : null;
    $[1] = hasSelectedTokens;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onRefetch) {
    t3 = <TokenHideButton onRefetch={onRefetch} />;
    $[3] = onRefetch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hasSelectedTokens) {
    t4 = hasSelectedTokens ? <><Separator className="mx-0 h-6 md:mx-3" orientation="vertical" /><ProfileTokensSelectionClearAll /></> : null;
    $[5] = hasSelectedTokens;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <FlexCenter className="gap-3">{t3}{t4}</FlexCenter>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <Media greaterThanOrEqual="md"><ItemSelectionActionBar><SpaceBetween className="w-full items-center"><FlexCenter className="gap-3">{t1}{t2}{t5}</FlexCenter></SpaceBetween></ItemSelectionActionBar></Media>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onRefetch) {
    t7 = <Media lessThan="md"><MobileProfileTokensActionBar onRefetch={onRefetch} /></Media>;
    $[13] = onRefetch;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(v) {
  return [v.selectedTokensMap];
}